/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
// import auth from '@/auth/authService'
// import webauth from './webauth/auth'
import store from './store/store'

// import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

function checkPermission (module, entity) {
  // alert(module); // Exams
  // alert(entity); // View
  let pagePermission = false
  let permissionList = []
  if (store.getters.get_role_permission === 1) {
    pagePermission = true
  } else {
    store.getters.get_navmenu_item_data.forEach(menu => {
      if (module === menu.module_name && menu.has_permission) {
        permissionList = menu.action_list

      }
    })
    permissionList.forEach(element => {
      if (element.action_name === entity && element.enabled === 1) {
        pagePermission = true
      } else if (element.action_name === 'ViewOwn' && element.enabled === 1) {
        pagePermission = true
      }
    })
  }

  return pagePermission
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [



    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: '/',
          name: '/',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/',
          name: 'paddle-products',
          component: () => import('@/views/pages/v1/signup/paddle-products.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/terms-and-conditions',
          name: 'terms-and-conditions',
          component: () => import('@/views/pages/v1/signup/terms-and-conditions.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/signup/:price_id',
          query: { plan_id: '' },
          name: 'signup',
          component: () => import('@/views/pages/v1/signup/index.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/Forgot-password.vue'),
          meta: {
            rule: 'editor',
            customerIdRequired: false
          }
        },
        {
          path: '/Password-setup',
          name: 'password-setup',
          component: () => import('@/views/pages/Password-setup.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/qr-code',
          name: 'qr-code',
          component: () => import('@/views/pages/login/LoginWithDevice.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: 'redirectgoogle',
          name: 'redirectgoogle',
          component: () => import('./views/pages/google-authenticate/googleauthenticate.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Authentication', active: true }
            ],
            rule: 'editor',
            parent: 'todo',
            no_scroll: true
          }
        },
        // {
        //   path: '/:subdomain/pages/login',
        //   name: '/',
        //   component: () => import('@/views/pages/login/Login.vue'),
        //   meta: {
        //     rule: 'editor',
        //     customerIdRequired: false
        //   }
        // },

        // {
        //   path: '/*/',
        //   name: '/',
        //   component: () => import('@/views/pages/login/Login.vue'),
        //   meta: {
        //     rule: 'editor',
        //     customerIdRequired: false
        //   }
        // },
        // {
        //   path: '/*/login',
        //   name: 'page-login',
        //   component: () => import('@/views/pages/login/Login.vue'),
        //   meta: {
        //     rule: 'editor',
        //     customerIdRequired: false
        //   }
        // },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/permission-denied',
          name: 'Permission denied',
          component: () => import('@/views/NoPermission.vue'),
          meta: {
            rule: 'editor'
          }
        },
        
      ]
    },
    // Redirect to login page, if no match found
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  document.body.classList.remove('overflow-hidden')
  if (to.meta.authRequired) {
    if (to.meta.customerIdRequired) {
      if (!store.getters.isUserLoggedIn) {
        router.push({ path: '/pages/login', query: { to: to.path } }).catch(() => {})
      } else if (store.getters.customerId === null) {
        router.push({ path: '/pages/switch', query: { to: to.path } }).catch(() => {})
      } else if (store.getters.token !== localStorage.getItem('access_token')) {
        window.location.reload()
      } else if (store.getters.customerId !== localStorage.getItem('customer_id')) {
        window.location.reload()
      } else if (to.meta.module) {
        if (localStorage.getItem('courseActionType') !== null && localStorage.getItem('courseActionType') === 'Edit') {
          to.meta.entity = 'Edit'
        }
        if (localStorage.getItem('courseActionType') !== null && localStorage.getItem('courseActionType') === 'customEdit') {
          to.meta.entity = 'customEdit'
        }
        if (localStorage.getItem('courseActionType') !== null && localStorage.getItem('courseActionType') === 'Shared') {
          to.meta.entity = 'View'
        }
        if (checkPermission(to.meta.module, to.meta.entity)) {
          return next()
        } else {
          router.push({ path: '/permission-denied' })
        }
      } else {
        return next()
      }
    } else if (!store.getters.isUserLoggedIn) {
      router.push({ path: '/pages/login', query: { to: to.path } }).catch(() => {})
    }
    return next()
  }
  return next()
})

export default router
